import { useTheme } from '../../components/ThemeProvider'

/**
 * Theme-aware color configuration for Recharts
 * Provides consistent colors across all chart components
 */
export const useChartColors = () => {
  const { theme } = useTheme()

  // Light mode colors (blue-purple palette)
  const lightColors = {
    primary: '#3b82f6',     // blue-500
    secondary: '#8b5cf6',   // purple-500
    tertiary: '#06b6d4',    // cyan-500
    accent: '#10b981',      // green-500
    warning: '#f59e0b',     // amber-500
    danger: '#ef4444',      // red-500
    info: '#6366f1',        // indigo-500
    success: '#22c55e',     // green-500

    // Gradients
    chartColors: [
      '#3b82f6', // blue
      '#8b5cf6', // purple
      '#06b6d4', // cyan
      '#10b981', // green
      '#f59e0b', // amber
      '#ef4444', // red
      '#6366f1', // indigo
      '#ec4899', // pink
    ],

    // Background colors
    background: '#ffffff',
    card: '#ffffff',
    tooltip: {
      background: 'rgba(255, 255, 255, 0.95)',
      border: '#e5e7eb',
      text: '#1f2937',
    },

    // Axis and grid
    axis: {
      line: '#e5e7eb',      // gray-200
      text: '#6b7280',      // gray-500
      grid: '#f3f4f6',      // gray-100
    },
  }

  // Dark mode colors (orange-amber palette)
  const darkColors = {
    primary: '#f97316',     // orange-500
    secondary: '#fbbf24',   // amber-400
    tertiary: '#fb923c',    // orange-400
    accent: '#34d399',      // emerald-400
    warning: '#fbbf24',     // amber-400
    danger: '#f87171',      // red-400
    info: '#60a5fa',        // blue-400
    success: '#4ade80',     // green-400

    // Gradients
    chartColors: [
      '#f97316', // orange
      '#fbbf24', // amber
      '#fb923c', // orange-400
      '#34d399', // emerald
      '#f87171', // red
      '#60a5fa', // blue
      '#a78bfa', // purple
      '#f472b6', // pink
    ],

    // Background colors
    background: '#0a0a0a',
    card: '#1a1a1a',
    tooltip: {
      background: 'rgba(26, 26, 26, 0.95)',
      border: '#2a2a2a',
      text: '#f5f5f5',
    },

    // Axis and grid
    axis: {
      line: '#2a2a2a',
      text: '#a3a3a3',
      grid: '#1a1a1a',
    },
  }

  return theme === 'dark' ? darkColors : lightColors
}

/**
 * Default chart options that work well in both themes
 */
export const getDefaultChartOptions = () => ({
  margin: { top: 20, right: 20, left: 20, bottom: 20 },
  responsive: true,
  maintainAspectRatio: false,
})
